import React from 'react';
import { Link } from 'react-router-dom';

import SectionHeader from '../../shared/section-header';

import style from './index.module.scss';

function AnswerLater() {
  const { header, answer, title, answers, action } = style;

  return (
    <>
      <div className={header}>
        <SectionHeader headingLeft="Answer Later" colWidth={12} />
      </div>
      {[1, 2, 3, 4].map(x => (
        <div className={`card ${answer}`} key={x}>
          <h4 className={title}>
            How many years do we likely have left on this planet?
          </h4>
          <p className={`text-muted ${style['num-of-answers']}`}>
            <Link to="/account/profile" className={answers}>
              120 answers
            </Link>
            · Last followed {'4 d'} ago
          </p>
          <div className={`col-12 ${style['col--actions']}`}>
            <span className={action}>
              <i className="fas fa-edit" /> Answer
            </span>
            <span className={action}>
              <i className="fas fa-times" /> Remove
            </span>
          </div>
        </div>
      ))}
    </>
  );
}

export default AnswerLater;
